// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main{
  margin-top: 5%;
}

.nama-text {
  height: 25px !important;
  width: 100% !important;
  color: black;
  padding: 6% !important; 
}

.Form {
  height: 100vh !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  font-family: 'Poppins' !important;
}

.register {
  margin: auto ;
  max-width: 1010px;
  width: 100vw;
  display: flex;
  border: 1px solid #e9ecef;
  border-radius: 5px;
  /* box-shadow: 1px 3px 10px #e9ecef; */
  background-color: white;
}

.register span {
  color: #adb5bd;
}

#form {
  max-width: 310px;
  width: 100%;
  margin: 2em auto;
  height: 6% !important;
  margin-top: -5%;
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
  #form {
    height: auto; /* Mengubah tinggi agar disesuaikan dengan kontennya */
    margin-top: 0; /* Reset margin-top untuk tampilan mobile */
  }
}

/* Media query untuk iPad dengan lebar layar kurang dari 768px */
@media screen and (min-width: 577px) and (max-width: 768px) {
  #form {
    margin-top: -5%; /* Sesuaikan margin-top agar sesuai dengan tampilan iPad */
  }
}


#form > input,
.btn {
  border: 1px solid #e9ecef;
  padding: 0.9em 1em;
  border-radius: 5px;
 
}

#form > input:focus {
  outline: none;
  
}

#form > .btn {
  background-color: #0D4C92;
  color: #e9ecef;
  font-size: 1em;
  cursor: pointer;
}

.flex {
  display: flex;
  gap: 1em;
}

.flex-col {
  flex-direction: column;
}

.register .col-1 {
  margin: auto;
  padding: 3em 0;
}

.register .col-2 img {
  width: 515px;
  height: 100%;
  object-fit: cover;
  align-self: flex-end;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  display: none;
}
.open{
  display: block;
}
.close{
  display: none;
}

@media screen and (min-width: 860px) {
  .register .col-2 img {
    display: initial;
  }
  .button-next-form {
    display: flex;
  }
}


.selected{
  background-color: white !important;
  border: 7px solid var(--select-border);
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  font-size: 13px;
  padding: 0.675em 6em 0.675em 1em;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
  font-family: 'Poppins';
}

.nama-karyawan{
  font-family: 'Poppins';
  color: white;
  font-weight: bold;    
  margin-top: 50px !important;
}

.nama-event{
  font-family: 'Poppins';
  color: white;
  font-weight: bold;
}

.nama-modul{
  font-family: 'Poppins';
  color: white;
  font-weight: bold;
}

.input{
  color: black;
}

.btn-next-form{
  display: inline-block;
  margin-top: 1% !important;
  margin-left: 65% !important;
  background-color: #122329;
  color: #fff;
  border-radius: 4px;
  border: 4px;
  padding: 10px;
  margin: 5px;
  font: 15px;
  font-family: 'Poppins';
  font-weight: bold !important;
  cursor: pointer;
  width: 100px;
}

.back-icon-form {
  float: left;
  margin-top: -3%;
  /* padding-left: 1%; */
  font-size: 18px; /* Sesuaikan ukuran font sesuai kebutuhan */
  color: #fff;
}

/* Responsive styling using media queries */
@media screen and (max-width: 767px) {
  .back-icon-form {
      float: left; /* Menghapus float pada tampilan mobile */
      margin-top: -20%; /* Sesuaikan sesuai kebutuhan */
      text-align: center; /* Pusatkan ikon pada tampilan mobile */
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px) {
  .back-icon-form {
      margin-top: -20%; /* Sesuaikan sesuai kebutuhan */
  }
}

/* Tambahan untuk tampilan desktop */
@media screen and (min-width: 1025px) {
  .back-icon-form {
      margin-top: 0%; /* Sesuaikan sesuai kebutuhan */
  }
}

.wrapper-2 {
  max-width: 350px;
  min-height: 500px;
  height: 350px;
  margin: 80px auto;
  margin-top: -10px;
  background-color: #1d91b7 !important;
  border-radius: 15px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
  padding: 20px;
  overflow: auto;
}

/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */
@media screen and (max-width: 576px) {
  .wrapper-2 {
      max-width: 100%; /* Lebar penuh pada perangkat mobile */
      margin: 30px auto; /* Penyesuaian margin untuk tampilan mobile */
      margin-top: 15%; /* Reset margin-top untuk tampilan mobile */
  }
}

/* Media query untuk iPad dengan lebar layar kurang dari 768px */
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .wrapper-2 {
      margin-top: 20%;
  }
}

.dropdown {
  width: 200px; /* Set a default width for the dropdown */
}

/* Media query for smaller screens */
@media only screen and (max-width: 600px) {
  .dropdown {
    width: 100%; /* Make the dropdown full width on smaller screens */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AssessmentForm/AssessmentForm.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE;IACE,YAAY,EAAE,sDAAsD;IACpE,aAAa,EAAE,2CAA2C;EAC5D;AACF;;AAEA,gEAAgE;AAChE;EACE;IACE,eAAe,EAAE,0DAA0D;EAC7E;AACF;;;AAGA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;EAC5B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;EAIA;IACE,aAAa;EACf;AALF;;;AASA;EACE,kCAAkC;EAClC,sCAAsC;EAItC,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,sBAAsB;AAbxB;;AAgBA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,UAAU;EACV,sBAAsB;EACtB,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,eAAe,EAAE,2CAA2C;EAC5D,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE;MACI,WAAW,EAAE,yCAAyC;MACtD,gBAAgB,EAAE,+BAA+B;MACjD,kBAAkB,EAAE,uCAAuC;EAC/D;AACF;;AAEA;EACE;MACI,gBAAgB,EAAE,+BAA+B;EACrD;AACF;;AAEA,oCAAoC;AACpC;EACE;MACI,cAAc,EAAE,+BAA+B;EACnD;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE;MACI,eAAe,EAAE,sCAAsC;MACvD,iBAAiB,EAAE,6CAA6C;MAChE,eAAe,EAAE,2CAA2C;EAChE;AACF;;AAEA,gEAAgE;AAChE;EACE;MACI,eAAe;EACnB;AACF;;AAEA;EACE,YAAY,EAAE,yCAAyC;AACzD;;AAEA,oCAAoC;AACpC;EACE;IACE,WAAW,EAAE,oDAAoD;EACnE;AACF","sourcesContent":[".main{\n  margin-top: 5%;\n}\n\n.nama-text {\n  height: 25px !important;\n  width: 100% !important;\n  color: black;\n  padding: 6% !important; \n}\n\n.Form {\n  height: 100vh !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  text-align: center !important;\n  font-family: 'Poppins' !important;\n}\n\n.register {\n  margin: auto ;\n  max-width: 1010px;\n  width: 100vw;\n  display: flex;\n  border: 1px solid #e9ecef;\n  border-radius: 5px;\n  /* box-shadow: 1px 3px 10px #e9ecef; */\n  background-color: white;\n}\n\n.register span {\n  color: #adb5bd;\n}\n\n#form {\n  max-width: 310px;\n  width: 100%;\n  margin: 2em auto;\n  height: 6% !important;\n  margin-top: -5%;\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n  #form {\n    height: auto; /* Mengubah tinggi agar disesuaikan dengan kontennya */\n    margin-top: 0; /* Reset margin-top untuk tampilan mobile */\n  }\n}\n\n/* Media query untuk iPad dengan lebar layar kurang dari 768px */\n@media screen and (min-width: 577px) and (max-width: 768px) {\n  #form {\n    margin-top: -5%; /* Sesuaikan margin-top agar sesuai dengan tampilan iPad */\n  }\n}\n\n\n#form > input,\n.btn {\n  border: 1px solid #e9ecef;\n  padding: 0.9em 1em;\n  border-radius: 5px;\n \n}\n\n#form > input:focus {\n  outline: none;\n  \n}\n\n#form > .btn {\n  background-color: #0D4C92;\n  color: #e9ecef;\n  font-size: 1em;\n  cursor: pointer;\n}\n\n.flex {\n  display: flex;\n  gap: 1em;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.register .col-1 {\n  margin: auto;\n  padding: 3em 0;\n}\n\n.register .col-2 img {\n  width: 515px;\n  height: 100%;\n  object-fit: cover;\n  align-self: flex-end;\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  display: none;\n}\n.open{\n  display: block;\n}\n.close{\n  display: none;\n}\n\n@media screen and (min-width: 860px) {\n  .register .col-2 img {\n    display: initial;\n  }\n}\n\n@media screen and (min-width: 860px) {\n  .button-next-form {\n    display: flex;\n  }\n}\n\n\n.selected{\n  background-color: white !important;\n  border: 7px solid var(--select-border);\n}\n\n.selected{\n  appearance: none;\n  -webkit-appearance: none;\n  width: 100%;\n  font-size: 13px;\n  padding: 0.675em 6em 0.675em 1em;\n  background-color: #fff;\n  border: 1px solid #caced1;\n  border-radius: 0.25rem;\n  color: #000;\n  cursor: pointer;\n  font-family: 'Poppins';\n}\n\n.nama-karyawan{\n  font-family: 'Poppins';\n  color: white;\n  font-weight: bold;    \n  margin-top: 50px !important;\n}\n\n.nama-event{\n  font-family: 'Poppins';\n  color: white;\n  font-weight: bold;\n}\n\n.nama-modul{\n  font-family: 'Poppins';\n  color: white;\n  font-weight: bold;\n}\n\n.input{\n  color: black;\n}\n\n.btn-next-form{\n  display: inline-block;\n  margin-top: 1% !important;\n  margin-left: 65% !important;\n  background-color: #122329;\n  color: #fff;\n  border-radius: 4px;\n  border: 4px;\n  padding: 10px;\n  margin: 5px;\n  font: 15px;\n  font-family: 'Poppins';\n  font-weight: bold !important;\n  cursor: pointer;\n  width: 100px;\n}\n\n.back-icon-form {\n  float: left;\n  margin-top: -3%;\n  /* padding-left: 1%; */\n  font-size: 18px; /* Sesuaikan ukuran font sesuai kebutuhan */\n  color: #fff;\n}\n\n/* Responsive styling using media queries */\n@media screen and (max-width: 767px) {\n  .back-icon-form {\n      float: left; /* Menghapus float pada tampilan mobile */\n      margin-top: -20%; /* Sesuaikan sesuai kebutuhan */\n      text-align: center; /* Pusatkan ikon pada tampilan mobile */\n  }\n}\n\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .back-icon-form {\n      margin-top: -20%; /* Sesuaikan sesuai kebutuhan */\n  }\n}\n\n/* Tambahan untuk tampilan desktop */\n@media screen and (min-width: 1025px) {\n  .back-icon-form {\n      margin-top: 0%; /* Sesuaikan sesuai kebutuhan */\n  }\n}\n\n.wrapper-2 {\n  max-width: 350px;\n  min-height: 500px;\n  height: 350px;\n  margin: 80px auto;\n  margin-top: -10px;\n  background-color: #1d91b7 !important;\n  border-radius: 15px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  overflow: auto;\n}\n\n/* Media query untuk perangkat mobile dengan lebar layar kurang dari 576px */\n@media screen and (max-width: 576px) {\n  .wrapper-2 {\n      max-width: 100%; /* Lebar penuh pada perangkat mobile */\n      margin: 30px auto; /* Penyesuaian margin untuk tampilan mobile */\n      margin-top: 15%; /* Reset margin-top untuk tampilan mobile */\n  }\n}\n\n/* Media query untuk iPad dengan lebar layar kurang dari 768px */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n  .wrapper-2 {\n      margin-top: 20%;\n  }\n}\n\n.dropdown {\n  width: 200px; /* Set a default width for the dropdown */\n}\n\n/* Media query for smaller screens */\n@media only screen and (max-width: 600px) {\n  .dropdown {\n    width: 100%; /* Make the dropdown full width on smaller screens */\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
